package com.neurobs.ccab

import com.neurobs.util.JsonPrinter.jsonPrint
import com.opentok.{MediaMode, OpenTok, Role, SessionProperties, TokenOptions}
import io.circe.generic.auto._

case class OpentokTokenData
(
	apiKey: Int,
	sessionId: String,
	token: String
)

class OpentokTokenGenerator (apiKey: Int, apiSecret: String) {
	private val openTok = new OpenTok(apiKey, apiSecret)

	def generate(client: ChatClientId, existingSessionId: Option[String]): OpentokTokenData = {
		val options = (new TokenOptions.Builder).
			data(jsonPrint(client)).
			role(Role.PUBLISHER).
			build()

		existingSessionId match {
			case Some(sessionId) =>
				OpentokTokenData(apiKey = apiKey, sessionId = sessionId, token = openTok.generateToken(sessionId, options))
			case None =>
				val sessionProps = (new SessionProperties.Builder).mediaMode(MediaMode.ROUTED).build()
				val session = openTok.createSession(sessionProps)
				OpentokTokenData(apiKey = apiKey, sessionId = session.getSessionId, session.generateToken(options))
		}
	}
}